import { useCreateTemplateMutation } from '@/graphql/types';

export default function (template: {
  name: string;
  templateId: string;
  description: string;
  attributes: {
    sc1187: any;
    sc1009: any;
    sensorMapping: string;
    description: string;
  }[];
}) {
  const mutation = useCreateTemplateMutation({});

  function call() {
    return mutation.mutate({
      input: {
        name: template.name,
        description: template.description,
        templateId: +template.templateId,
        attributes: [
          ...template.attributes.map(attr =>
            Object.assign(
              {},
              {
                sc1187Id: attr.sc1187.id,
                sc1009Id: attr.sc1009.id,
                sensorMapping: attr.sensorMapping,
                description: attr.description
              }
            )
          )
        ]
      }
    });
  }

  return {
    ...mutation,
    call
  };
}
